<pims-loader />
<div class="app-main">
    <mat-sidenav-container [hasBackdrop]="false" [autosize]="true">
        <mat-sidenav #drawer mode="side" [opened]="true">
            <pims-side-menu />
        </mat-sidenav>
        <mat-sidenav-content>
            <pims-profile-header />
            <div class="outlet-area" id="outlet">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
